module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Ghostly Tales of Phoenix")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")]), _vm._v(" & M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AP")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "350px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Front3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome to Spooky Phoenix!")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Central District")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch1.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St Mary’s Basilica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch2.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arizona State Capitol")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch3.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke-Greenway American Legion Post 1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch4.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YMCA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch5.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’edav Va’aki Museum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch6.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Baptist Church")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch7.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Washington Carver Museum and Cultural Center")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch8.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Westward Ho Hotel")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Warehouse District")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch9.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#h_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phoenix Union Station")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch10.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#h_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Santa Fe Freight Depot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch11.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#h_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Icehouse")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phantoms of the Theater")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch12.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#h_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phoenix Theatre")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch13.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#h_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orpheum Theatre")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tales from the Crypt")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Arizona Tombstone Rescue")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch14.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hohokam Dig: The Real Ghosts of Pioneer & Military Memorial Park")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch15.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Sisto”: The Old Gravedigger of the Phoenix Cemetery")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch16.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunt’s Tomb")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch17.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pioneer Living Museum")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victorian House")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flying V Cabin")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ashurst Cabin")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merritt House")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Northern Home")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opera House")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Road")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysteries of the Underground")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch18.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#h_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gold Spot Bowling Alley")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch19.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#h_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phoenix’s Bat Cave")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Mansions")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch20.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#h_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evans House")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch21.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#h_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norton House")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch22.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#h_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellis-Shackelford House")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairy Tale Castles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch23.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#h_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mystery Castle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/tch24.jpg"
    }
  })]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#h_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tovrea Castle")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Ghostly Goodbye")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0